import React from 'react';
import Section from '../components/section';
import { Typography, styled, Box } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  return (
    <Section bgColor='black'>
      <ContentWrapper>
        <InfoBlock>
          <Typography variant='subtitle1' fontWeight={600} color="white">
            Lukratech s.r.o.
          </Typography>
          <InfoLine>
            <LocationOnIcon fontSize="small" />
            <span>Študentská 4, 04001 Košice</span>
          </InfoLine>
          <InfoLine>
            <EmailIcon fontSize="small" />
            <span>lukratech@gmail.com</span>
          </InfoLine>
        </InfoBlock>
        <Title variant='subtitle2'>
          Vytvorila{' '}
          <Typography variant='subtitle1' component={'span'}>
            <a href='http://www.linkedin.com/in/lucia-kravcova' target='blank'>
              Ing. Lucia Kravcová
            </a>{' '}
          </Typography>
          | 2025
        </Title>
      </ContentWrapper>
    </Section>
  );
};

export default Footer;

// Styled Components
const Title = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontWeight: 600,
  textAlign: 'center',
  marginTop: theme.spacing(2),
  '& a': {
    color: 'white',
    textDecoration: 'none',
  },
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const InfoBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: 'white',
  gap: theme.spacing(1),
}));

const InfoLine = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: '0.9rem',
}));

